import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const testimonials: [string, string, string][] = [['“This is exactly what I needed. My class finally has a clear path.”', 'María', 'Primary Teacher'], ['“I’m not a native speaker and I felt confident from day one.”', 'James', 'Year 7 Teacher'], ['“The assessments saved me hours every week.”', 'Sofia', 'HOD Languages'], ['“Every unit is planned, so I walk in ready to teach.”', 'Daniel', 'Secondary Teacher'], ['“The speaking tasks finally got my students talking.”', 'Aisha', 'Languages Lead'], ['“It brings real structure to our homeschool Spanish time.”', 'Rachel', 'Homeschool Parent']];
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-154" data-mp="2yfpaqldxvkrq">
      <Reveal className="mx-auto max-w-6xl" data-id="element-155" data-mp="32hav0rssz1by">
        <div className="mb-12 text-center" data-id="element-156" data-mp="32fzr8rzcxtku">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-157" data-mp="2v12ml22q2lbp">
            TEACHER FAVOURITE
          </p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-158" data-mp="2q1pzqhbupe94">
            What Spanish Teachers Are Saying.
          </h2>
          <p className="mt-4 font-semibold text-brand-gray" data-id="element-159" data-mp="34t8d07dbsuos">
            ⭐⭐⭐⭐⭐ Made for confident, culture-rich Spanish teaching
          </p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-160" data-mp="2c3rmxgd6hpvq">
          {testimonials.map(([quote, name, role]) => <article key={name} className="flex min-h-[220px] flex-col rounded-2xl border border-brand-dark bg-brand-main p-7" data-id="element-161" data-mp="275gena2j7nfm">
              <div className="flex gap-1" data-id="element-162" data-mp="2h0rszra12smu">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-163" data-mp="19m4dquyb4sb" />)}
              </div>
              <p className="mt-5 flex-1 font-serif text-lg italic leading-relaxed" data-id="element-164" data-mp="3eis064asmfl">
                {quote}
              </p>
              <div className="mt-6" data-id="element-165" data-mp="8foiryeedzmh">
                <p className="text-sm font-bold text-brand-blue" data-id="element-166" data-mp="dcoou9b8z2dl">{name}</p>
                <p className="text-xs text-brand-gray" data-id="element-167" data-mp="ibrkj35c7w8w">{role}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}